import React, {Component} from "react";
import './index.less'

import AwesomeSwiper from 'react-awesome-swiper';

export default class PortalContentProduction extends Component{
    constructor(props) {
        super(props)
        this.state = {
            productList:[
                {
                    page:1,
                    children:[
                        {url:"",productName:"BIM土建计量GTJ", productIcon:require("./images/2-BIM土建计量GTJ.png")},
                        {url:"",productName:"广联达新计价GCCP6.0", productIcon:require("./images/1-广联达新计价GCCP6.0.png")},
                        {url:"",productName:"BIM安装计量GDQ", productIcon:require("./images/3-BIM安装计量GDQ.png")},
                        {url:"",productName:"BIM市政计量GMA", productIcon:require("./images/4-BIM市政计量GMA.png")},
                        {url:"",productName:"BIM钢结构计量GJG", productIcon:require("./images/6-BIM钢结构计量GJG.png")},
                        {url:"",productName:"BIM装饰计量", productIcon:require("./images/5-BIM装饰计量.png")},
                        {url:"",productName:"广联达BIM+智慧工地数据决策系统", productIcon:require("./images/1-广联达BIM+智慧工地数据决策系统.png")},
                        {url:"",productName:"广联达智能物料验收系统", productIcon:require("./images/2-广联达智能物料验收系统.png")},
                        {url:"",productName:"广联达现场劳务管理系统", productIcon:require("./images/4-广联达现场劳务管理系统.png")},
                        {url:"",productName:"施工安全管理系统", productIcon:require("./images/3-施工安全管理系统.png")},
                    ]
                },
                {
                    page:2,
                    children:[
                        {url:"",productName:"基础数据管理", productIcon:require("./images/8-基础数据管理.png")},
                        {url:"",productName:"广联达现场生产管理系统", productIcon:require("./images/5-广联达现场生产管理系统.png")},
                        {url:"",productName:"斑马进度计划", productIcon:require("./images/7-斑马进度计划.png")},
                        {url:"",productName:"广联达BIM+技术管理系统", productIcon:require("./images/6-广联达BIM+技术管理系统.png")},
                        {url:"",productName:"质量管理系统", productIcon:require("./images/9-质量管理系统.png")},
                    ]
                }


            ]
        }
    }

    handleIconClick = (url) => {
        if(url){
            window.open(url,"_blank ")
        }
    }

    render() {
        let { productList } = this.state
        let { handleIconClick } = this

        const config = {
            loop : true,
            preloadImages: false,
            lazy: true,
            speed: 500,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                slideChange: function () {
                    // console.log(this.activeIndex);
                },
            },
        };

        return (
            <div className={'portal-content-production w1200'} id={'portalProduction'}>
                <h2>应用产品</h2>
                <div style={{height:310,padding:'0'}}>
                    <AwesomeSwiper ref={ref => (this.swiperRef = ref)} config={config} className="your-classname">
                        <div className="swiper-wrapper">
                            {
                                productList.map(ele => {
                                    return (
                                        <div className="swiper-slide" key={ele.page}>
                                            <div className={'swiper-slide-content'} style={{padding:'0px 60px'}}>
                                                {
                                                    ele.children.map(item => {
                                                        return (
                                                            <div onClick={() => {
                                                                handleIconClick(item.url)
                                                            }} className={'swiper-slide-content-item'} key={JSON.stringify(item)}>
                                                                <img width={100} height={100} src={item.productIcon} alt=""/>
                                                                <p>{item.productName}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                        <div className="swiper-button-prev swiper-button-black swiper-btn"></div>
                        <div className="swiper-button-next swiper-button-black swiper-btn"></div>
                    </AwesomeSwiper>
                </div>
            </div>
        )
    }
}